import TopNav from './TopNav/index';
import BaseSelect from './BaseSelect/index';
import BaseFormM from './BaseFormM/index';

const components = {
  TopNav,
  BaseSelect,
  BaseFormM
};
const install = function (Vue) {
  for (const component of Object.values(components)) {
    Vue.component(component.name, component);
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install
};